<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="mar_code,de_product_type,de_name,mar_decode"
      placeholder="输入单号、产品类型、项目名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/plm/market_report/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.mar_code }}</p>
          <p class="list-item-muted">{{ item.de_name }}&nbsp;{{ item.mar_emname }}</p>
        </div>
        <div class="weui-cell__ft">
          <p >{{ item.de_product_type }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.mar_status != '已审核' }"
            >{{ item.mar_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/plm/marketAnalyseReport/list",
      filters: [
        {
          type: "date",
          name: "a.createTime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "mar_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "mar_status='已审核'",
            },
          ],
        },
      ],
    };
  },
};
</script>